import React from 'react'
import { Modal, Form, Col, Row, Button, ListGroup } from 'react-bootstrap'
import { createModal, ModalResolveType, useModalAction } from '@src/lib/modal-manager'
import { useFetch } from '@src/hooks'
import { useForm } from '@src/lib/react-hook-form'
import z from 'zod'
import { UserService } from '@src/domain/services'
// import { RoleDto } from '@src/domain/repositories/system.repo'

interface EditUserProps {
  dtoUuid?: string;
  itemDto?: RoleDto;
}

interface RoleDto {
  code?: string,
  description: string,
  permissionUuids: string[],
  status: string
}

const initState: RoleDto = {
  code: '',
  description: '',
  permissionUuids: [],
  status: '1',
}

export function EditRoleModalWrapper(props: EditUserProps) {
  const { resolve, remove, hide } = useModalAction()
  const { dtoUuid, itemDto } = props

  const { register, handleSubmit, formState: { errors } } = useForm<RoleDto>({
    reValidateMode: 'onSubmit',
    defaultValues: {...initState, ...itemDto},
    rules: z.object({
      description: z.string().nonempty({ message: '角色名稱' }),
      code: z.string().nonempty({ message: '角色代碼' }),
      permissionUuids: z.string().array().min(1, { message: '' }),
      status: z.string().nonempty({ message: '請選擇狀態' })
    })
  })

  const { data: permissionOptions = [] } = useFetch(UserService.getPermissions, null)

  const handleClose = () => {
    resolve(ModalResolveType.CLOSED)
    hide()
    remove()
  }

  const handleCancel = () => {
    resolve(ModalResolveType.CANCEL)
    hide()
    remove()
  }

  const handleOnSubmit = (formDto: RoleDto) => {
    resolve(ModalResolveType.OK, formDto)
    hide()
    remove()
  }

  return (
    <Modal size='lg' show onHide={handleClose} centered>
      <Form onSubmit={handleSubmit(handleOnSubmit)}>
        <Modal.Header closeButton>
          <Modal.Title>{`${dtoUuid ? '編輯' : '新增'}使用者`}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm="2">
              角色名稱
            </Form.Label>
            <Col sm="10">
              <Form.Control placeholder="Ex: 現場主管" {...register('description')} />
            </Col>
            {errors.description && <Form.Text className='text-danger'>{errors.description.message}</Form.Text>}
          </Form.Group>
          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm="2">
              角色代碼
            </Form.Label>
            <Col sm="10">
              <Form.Control placeholder="Ex: Manager" {...register('code')} />
            </Col>
            {errors.code && <Form.Text className='text-danger'>{errors.code.message}</Form.Text>}
          </Form.Group>
          <ListGroup className="mb-3" style={{ height: '20rem', maxHeight: '36rem', overflowY: 'auto', borderRadius: '0' }}>
            {
              permissionOptions.map(pioItem => {
                return <ListGroup.Item style={{ border: 'none' }} key={pioItem.uuid}>
                  <Form.Check
                    type='checkbox'
                    value={pioItem.uuid}
                    label={pioItem.description}
                    {...register('permissionUuids')}
                  />
                </ListGroup.Item>
              })
            }
          </ListGroup>
          <Form.Group as={Row} className='mb-3'>
            <Form.Label column sm='2'>
              狀態
            </Form.Label>
            <Col sm='10'>
              <Form.Select {...register('status')}>
                <option value='1'>啟用</option>
                <option value='0'>停用</option>
              </Form.Select>
            </Col>
            {errors.status && <Form.Text className='text-danger'>{errors.status.message}</Form.Text>}
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleCancel} variant='light'>
            取消
          </Button>
          <Button type='submit'>
            確認
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  )
}

export const EditRoleModal = createModal(EditRoleModalWrapper)
